import { Component, Input } from '@angular/core';
import { Customer, CustomerAlert } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus, StandardColorRed } from '../../../../../../../utils';

@Component({
  selector: 'app-add-customer-alert-modal',
  templateUrl: './add-customer-alert-modal.component.html',
  styleUrls: ['./add-customer-alert-modal.component.css']
})
export class AddCustomerAlertModalComponent {

  @Input() customer: Customer;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public customerAlert: CustomerAlert = {
    id: null,
    url: '',
    alert_text: '',
    is_removed: false,
    expiry_date: '',
    color_hex: StandardColorRed.colorHex,
    prevents_check_in: false,
    has_alert_icon: false,
    created_by_id: null,
    created_by_email: '',
    updated_by_id: null,
    updated_by_email: '',
    created_date: '',
    updated_date: '',
    created_at: '',
    updated_at: ''
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .addCustomerAlert(
        this.customer.id,
        this.customerAlert
      )
      .then(createdAlert => {
        this.savedCallback({
          text: 'Alert created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create customer alerts.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
